import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpacemacsComponent } from './simple-icons-spacemacs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpacemacsComponent ],
    exports:      [ SimpleIconsSpacemacsComponent ],
    bootstrap:    []
})
export class SimpleIconsSpacemacsModule {}
